import React from 'react';
import styled from 'styled-components';
import { TestimonialWrapper, TestimonialText } from 'Components/Testimonials/Testimonial';
import { UseDesktopIcon } from 'assets/icons';

const StartTrial: React.FC = () => {
  return (
    <TestimonialWrapperStyled>
      <Title>A quick note from the Sked team</Title>
      <TestimonialTextStyled>
        Sked’s tools are optimized for desktop browsers. Please log in from your computer to access
        our platform.
      </TestimonialTextStyled>
      <Flex>
        <UseDesktopIcon />
      </Flex>
    </TestimonialWrapperStyled>
  );
};

export default StartTrial;

const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  text-transform: uppercase;
  color: var(--white);
  margin-bottom: 10px;
  letter-spacing: -1.1px;
`;

const TestimonialWrapperStyled = styled(TestimonialWrapper)`
  margin-top: 11px;
  padding: 20px;
  width: 100%;
  min-height: auto;
`;

const TestimonialTextStyled = styled(TestimonialText)`
  letter-spacing: -0.7px;
  font-size: 18px;
  line-height: 19px;
`;

const Flex = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
`;
